<template>
  <div >
  <!-- Hero Section -->
  <div class="home-page"><HeroSection /></div>
  <!-- Services Section -->    
  <div><ServicesSection /></div>
    
    
  </div>
</template>

<script>
// Import the HeroSection and ServicesSection components
import HeroSection from './HeroSection.vue';
import ServicesSection from './ServicesSection.vue';

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    ServicesSection,
  },
};
</script>

<style scoped>
.home-page {
  display: flex;
  justify-content: center;
  font-family: Arial, sans-serif;
}
</style>
